import { Button } from '@abyss/web/ui/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'usehooks-ts';

import { phoneOnly } from '../../../common/ConstantsStyles';
import { BtnWrapper } from './MapViewStickyButton.style';

type Props = {
  isSameLocationSelected: boolean;
  handleSaveLocation: () => void;
  updateLocation?: Boolean;
  handleCancel?: () => void;
};

export const MapViewStickyButton = ({
  isSameLocationSelected,
  handleSaveLocation,
  handleCancel,
  updateLocation,
}: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  return (
    <BtnWrapper mobileScreen={mobileScreen}>
      <Button
        css={{
          'abyss-button-content-container': {
            lineHeight: '20px',
          },
          'abyss-button-root': {
            height: '42px',
            fontSize: '16px',
            fontWeight: '$semibold',
            borderWidth: '2px',
            '.abyss-insert-element-after': {
              paddingLeft: 0,
            },
          },
        }}
        data-auto-testid="map-view-cancel"
        data-testid="map-view-cancel"
        onClick={handleCancel}
        variant="outline"
      >
        {t('SAVE_PROVIDER_LOCATION_MODAL.CANCEL_BUTTON')}
      </Button>
      <Button
        css={{
          'abyss-button-content-container': {
            color: !isSameLocationSelected ? '' : '#6E7072',
            lineHeight: '20px',
          },
          'abyss-button-root': {
            height: '42px',
            background: !isSameLocationSelected ? '' : '#F2F2F2 !important',
            fontSize: '16px',
            fontWeight: '$semibold',
            borderWidth: '2px',
            borderColor: !isSameLocationSelected ? '' : '#F2F2F2 !important',
            '.abyss-insert-element-after': {
              paddingLeft: 0,
            },
          },
        }}
        data-auto-testid="map-view-save-location"
        data-testid="map-view-save-location"
        isDisabled={isSameLocationSelected}
        onClick={handleSaveLocation}
      >
        {updateLocation
          ? t('SAVE_PROVIDER_LOCATION_MODAL.SAVE_BUTTON')
          : t('CARE_TEAM.VIEW_DIRECTION')}
      </Button>
    </BtnWrapper>
  );
};
